if (!window.retailer) {
    window.retailer = {};
    //turn on debug mode
    window.retailer.debug = true;
}
if (!window.retailer.debug) {
    console.log = function () { };
}
console.log("In config.js");
let serverParam = require('./params_public.js');
window.retailer.param = {
    NUM_ROUNDS: serverParam.NUM_ROUNDS,
    NUMBER_OF_WEEKS: serverParam.NUMBER_OF_WEEKS,
    INITIAL_INVENTORY: serverParam.INITIAL_INVENTORY,
    PRICE: serverParam.PRICE,
    PRICE_LABEL: serverParam.PRICE_LABEL,
    SALVAGE_VALUE: serverParam.SALVAGE_VALUE,
    IS_FIXED_WEEKONE: serverParam.IS_FIXED_WEEKONE,
};
window.retailer.stageThreeParam = {
    NUM_ROUNDS: serverParam.NUM_ROUNDS,
    NUMBER_OF_WEEKS: serverParam.NUMBER_OF_WEEKS,
    INITIAL_INVENTORY: serverParam.INITIAL_INVENTORY,
    PRICE: serverParam.PRICE_NEW,
    PRICE_LABEL: serverParam.PRICE_LABEL_NEW,
    SALVAGE_VALUE: serverParam.SALVAGE_VALUE,
    IS_FIXED_WEEKONE: serverParam.IS_FIXED_WEEKONE,
};



// WEBPACK FOOTER //
// ../public/js/retailer.config.js